/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enroll_Account_SuccessInputs */



/**
* | output |
* | --- |
* | "Your account has been created successfully" |
*
* @param {Enroll_Account_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const enroll_account_success = /** @type {((inputs?: Enroll_Account_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enroll_Account_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your account has been created successfully")
	return /** @type {LocalizedString} */ ("Votre compte a été créé avec succès")
});